import React from 'react';
import StarFull from '../../Assets/Lens/StarFull.svg';
import StarEmpty from '../../Assets/Lens/StarEmpty.svg';
import StarHalf from '../../Assets/Lens/StarHalf.svg';

const StarRating = ({ rating }) => {
    const getStars = () => {
        const stars = [];
        for (let i = 1; i <= 5; i++) {
            if (i <= rating) {
                stars.push(
                    <div key={i} className="w-5 h-5 flex items-center justify-center">
                        <img src={StarFull} alt="Full Star" />
                    </div>
                );
            } else if (i - 0.5 <= rating) {
                stars.push(
                    <div key={i} className="relative w-5 h-5 flex items-center justify-center">
                        <img src={StarEmpty} alt="" />

                        <img className='absolute top-[2.5px] left-[2.5px]' src={StarHalf} alt="" />
                    </div>
                );
            } else {
                stars.push(
                    <div key={i} className="w-5 h-5 flex items-center justify-center">
                        <img src={StarEmpty} alt="Empty Star" />
                    </div>
                );
            }
        }
        return stars;
    };

    return (
        <div className="flex items-center gap-1">
            <div className="flex items-center">
                {getStars()}
            </div>
            <h1 className="font-normal text-[12px] leading-6 text-[#121212]">{rating.toFixed(1)}</h1>
        </div>
    );
};

export default StarRating;
